export default "__VITE_ASSET__BflrLRVR__"